const bucket =
  'https://wildgamebutcher-dev.s3.us-east-1.amazonaws.com/frontend-assets/';
const logo = 'https://wildgamebutcher-dev.s3.us-east-1.amazonaws.com/logo/';
export const Assets = {
  LOGO: bucket + 'Logo.png',
  LOGO_ICON: bucket + 'Logo_icon.png',
  BUTCHER_HOUSE: bucket + 'ButcherHouse.png',
  DEFAULT_PROFILE: bucket + 'ProfileImg.png',
  EDIT_ICON: bucket + 'EditIcon.png',
  SORT_ICON: bucket + 'SortIcon.png',
  ARCHIVES_ICON: bucket + 'Archives.png',
  DEFAULT_ACCOUNT_PROFILE: bucket + 'Account.png',
  INVOICE_GENERATION_COMPLETE: bucket + 'Man_with_success_medal.png',
  STAR_ICON: bucket + 'star-dynamic.png',
  ONBOARD_COMPLETION: bucket + 'RocketSuccess.png',
  NO_DATA_FOUND: bucket + 'NoDataFound.png',
  ORDER_CREATE: bucket + 'NewOrder.png',
  PRODUCT_PROCESSING: bucket + 'ProductProcessing.png',
  SERVICE_PROCESSING: bucket + 'ServiceProcessing.png',
  INVOICE: bucket + 'Invoice.png',
  CUSTOMER: bucket + 'Customers.png',
  PICKUP: bucket + 'PickUp.png',
  APP_SETTINGS: bucket + 'AppSettings.png',
  LOGO_WITH_TEXT: logo + 'LogoWithText.png',
  CONFIRMATION_SUCCESS: bucket + 'confirmation_success.png',
  CONFIRMATION_FAILURE: bucket + 'confirmation_failure.png',
};
